import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=1dfd38ad"
import script from "./Publication.vue?vue&type=script&lang=js"
export * from "./Publication.vue?vue&type=script&lang=js"
import style0 from "./Publication.vue?vue&type=style&index=0&id=1dfd38ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports